import { useState } from 'react'
import styled from 'styled-components'
import { DndContext, MouseSensor, TouchSensor, useSensor, useSensors, closestCenter, DragOverlay } from '@dnd-kit/core'
import KanbanSwimlane from './KanbanSwimlane'
import KanbanCard from './KanbanCard'

const AreaWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    overflow-x: auto;
    padding: 1rem 1rem 1.5rem;
    flex: 1;
    align-items: flex-start;
    min-height: 0;

    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.area.highBg} transparent;

    &::-webkit-scrollbar {
        height: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.area.highBg};
        border-radius: 3px;
    }
`

const KanbanArea = ({ config, tasksByStatus, parentId, parentEntity, parentPath, onDragEnd, onTaskCreated, nextStackRankForSwimlane }) => {
    const { swimlanes, card: cardConfig, subEntity } = config

    const [activeTask, setActiveTask] = useState(null)
    const [activeSwimlaneId, setActiveSwimlaneId] = useState(null)

    const sensors = useSensors(
        useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
        useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 8 } })
    )

    const grouped = tasksByStatus(swimlanes)

    const handleDragStart = (event) => {
        const { active } = event
        const swimId = active.data.current?.swimlaneId
        const col = grouped[swimId] ?? []
        setActiveTask(col.find(t => t.id === active.id) ?? null)
        setActiveSwimlaneId(swimId ?? null)
    }

    const handleDragEnd = (event) => {
        setActiveTask(null)
        setActiveSwimlaneId(null)
        onDragEnd(event, swimlanes)
    }

    const handleDragCancel = () => {
        setActiveTask(null)
        setActiveSwimlaneId(null)
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onDragCancel={handleDragCancel}
        >
            <AreaWrapper>
                {swimlanes.map(swimlane => (
                    <KanbanSwimlane
                        key={swimlane.id}
                        swimlane={swimlane}
                        tasks={grouped[swimlane.statusValue] ?? []}
                        parentId={parentId}
                        parentEntity={parentEntity}
                        parentPath={parentPath}
                        subEntity={subEntity}
                        cardConfig={cardConfig}
                        defaultPriority={config.defaultPriority}
                        onTaskCreated={onTaskCreated}
                        nextStackRank={nextStackRankForSwimlane(swimlane.statusValue, swimlanes)}
                    />
                ))}
            </AreaWrapper>

            <DragOverlay>
                {activeTask ? (
                    <KanbanCard
                        task={activeTask}
                        swimlaneId={activeSwimlaneId}
                        parentId={parentId}
                        parentEntity={parentEntity}
                        parentPath={parentPath}
                        subEntity={subEntity}
                        cardConfig={cardConfig}
                    />
                ) : null}
            </DragOverlay>
        </DndContext>
    )
}

export default KanbanArea
